<template>

  <div :class="sticky ? 'data-table-scrollable-wrapper' : ''">

    <v-data-table
        :headers="allowedHeaders"
        :items="items"
        :total-items="totalItems"
        :pagination.sync="pagination"
        :loading="loading"
        class="elevation-1 data-table-built-in-wrapper"
        :style="{'min-height': '300px', 'margin-bottom': '20px'}"
        :must-sort="true"
        :rows-per-page-items="rowsPerPageItems"
        :rows-per-page-text="'Rows per page'"
    >
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

      <template slot="no-data">
        <!-- TODO: error should be local to fetching only -->
        <m-pay-error-message
            :error="$store.getters.error"
            :serverReturnedNothing="serverReturnedNothing"
        />
      </template>

      <template v-if="csvQueryFunctionName" slot="actions-append">
        <v-btn small flat
               :loading="loading"
               :disabled="loading"
               color="secondary"
               @click="csvQueryFunctionName ==='transactionsAsCsv' ?
                $emit('exportWithLimit',pagination,filtering)
                : getItemsAsCsv()"
        >
          Export to .CSV
          <v-icon right dark>grid_on</v-icon>
        </v-btn>
      </template>

      <template slot="headers" slot-scope="{}">
        <tr>
          <th v-for="(header, index) in allowedHeaders"
              class="column"
              :class="sortingClasses(header)"
              :key="header.value"
              :style="{ 'min-width': header.width ? `${header.width}px` : '0' }"
              @click="updateSorting(header)"
          >
            <v-tooltip v-if="index === 0" bottom>
            <span slot="activator">
              <v-icon color="secondary" @click="getItems" class="pl-3 pr-1">
                refresh
              </v-icon>
            </span>
              <span>Refresh Table</span>
            </v-tooltip>

            <template v-else>
            <span v-show="'right' !== header.align">
              {{ header.text }}
            </span>
              <v-icon v-if="header.sortable === undefined || header.sortable" small>
                {{ $vuetify.icons.sort }}
              </v-icon>
              <span v-show="'right' === header.align">
            {{ header.text }}
          </span>
            </template>
          </th>
        </tr>
        <tr class="data-table__header__filter-row">
          <th v-for="(header, index) in allowedHeaders"
              class="column"
              :class="{ 'px-0': '' === header.text }"
              :key="header.value"
          >
            <v-tooltip v-if="index === 0" bottom>
            <span slot="activator">
              <v-icon color="secondary" @click="resetFilters" class="pl-3 pr-1">
                restore
              </v-icon>
            </span>
              <span>Reset Filters</span>
            </v-tooltip>
            <v-select v-if="enumerations[header.value]"
                      class="data-table__header-filter__drop-down"
                      clearable hide-details solo
                      :value="filtering[header.value]"
                      :items="enumerations[header.value].map(v => v.name)"
                      @change="updateFiltering(header.value, false, $event)"
            >
            </v-select>
            <input v-else-if="isBooleanType(header)"
                   type="checkbox"
                   @keyup.enter.stop="updateFiltering(header.value, false, $event)"
                   @change="updateFiltering(header.value, header.preventUpdateOnFocusLoss, $event)"
            />
            <input
                v-else-if="header.filterable !== false && !isDateField(header)"
                class="data-table__footer__filter"
                :value="decodeUriFilterValue(filtering[header.value])"
                :placeholder="isDateField(header) ? 'yyyy.mm.dd hh:mm' : ''"
                @keyup.enter.stop="updateFiltering(header.value, false, $event)"
                @change="updateFiltering(header.value, header.preventUpdateOnFocusLoss, $event)"
                @click.stop
            />
            <input
              v-else-if="header.filterable !== false && isDateField(header)
                                                    && queryFunctionName === 'soapLogs'"
              class="data-table__footer__filter"
              :value="filtering[header.value]"
              :placeholder="isDateField(header) ? 'DD.MM.YYYY HH:mm:ss' : ''"
              @keyup.enter.stop="updateFiltering(header.value, false, $event)"
              @change="updateFiltering(header.value, header.preventUpdateOnFocusLoss, $event)"
              @click.stop
            />
            <input
                v-else-if="header.filterable !== false && isDateField(header)"
                class="data-table__footer__filter"
                :value="filtering[header.value]"
                :placeholder="isDateField(header) ? 'DD.MM.YYYY' : ''"
                @keyup.enter.stop="updateFiltering(header.value, false, $event)"
                @change="updateFiltering(header.value, header.preventUpdateOnFocusLoss, $event)"
                @click.stop
            />
          </th>
        </tr>
      </template>

      <template slot="items" slot-scope="{ item }">
        <tr class="data-table__row">

          <td v-for="header in allowedHeaders" :key="header.value" :class="cellClass(header)">
            <slot :name="header.value"
                  :item="item"
                  :value="item[header.value]"
                  :itemId="item.id"
                  :field="header.value"
                  :header="header">
              <template v-if="header.value === 'status' && itemStatusClasses">
                <m-pay-status :value-classes="itemStatusClasses" :value="item.status"/>
              </template>
              <template v-else-if="customStatusesComponents &&
               containsHeader(header.value, customStatusesComponents)">
                <m-pay-status
                    :value-classes="getCustomStatusClass(header.value, customStatusesComponents)"
                    :value="getCustomStatusField(header.value, item)"/>
              </template>
              <template v-else-if="isBooleanType(header)">
                <div style="text-align: center">
                  <v-icon v-if="item[header.value] === true" small color="green">
                    check_circle
                  </v-icon>
                </div>
              </template>
              <template v-else-if="isDateField(header) && queryFunctionName === 'soapLogs'">
                {{ formatters.dateTimeWithFormat(item[header.value], 'DD.MM.YYYY HH:mm:ss') }}
              </template>
              <template v-else-if="isDateField(header)">
                {{ formatters.dateTime(item[header.value]) }}
              </template>
              <template v-else>
                {{ getValue(item, header.value) }}
              </template>
            </slot>
          </td>

        </tr>
      </template>
    </v-data-table>

  </div>

</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import MPayErrorMessage from './MPayErrorMessage';
import MPayStatus from './MPayStatus';
import queries from '../utils/queries';
import formatters from '../utils/formatters';
import store from '../store';

export default {
  name: 'MPayGenericPagingTable',

  components: {
    MPayErrorMessage,
    MPayStatus,
  },

  props: {
    headers: { type: Array, required: true },
    queryFunctionName: { type: String, required: true },
    csvQueryFunctionName: { type: String, required: false },
    itemStatusClasses: { type: Object, required: false },
    customStatusesComponents: { type: Object, required: false },
    cellClasses: { type: Object, required: false },
    sticky: { type: Boolean, required: false, default: true },
    parentId: { type: String, required: false },
    rowsPerPageItems: {
      type: Array,
      default: () => [50, 100, 200],
    },
  },

  data: () => ({
    items: [],
    enumerations: {},
    totalItems: 0,
    pagination: {
      rowsPerPage: 50,
      sortBy: 'createdDate',
      descending: true,
    },
    defaultRowPerPageForSpecificTabs: [
      { title: 'Credit Offers', size: 200 },
      { title: 'Loans', size: 200 },
      { title: 'Soap Logs', size: 10 },
    ],
    filtering: {},
    serverReturnedNothing: '',
    loading: false,
    formatters,
    query: {},
    recordsLimit: 0,
  }),

  computed: {
    ...mapState({
      financingFilter: state => state.financingFilter,
    }),
    allowedHeaders() {
      return this.headers.filter((h) => {
        if (h.role) {
          return this.$store.getters.hasAnyRole(h.role);
        }
        return true;
      });
    },
    canApplyFinancingFilter() {
      return this.$route.path.includes('/financing/');
    },
  },

  methods: {
    containsHeader(value, map) {
      return Object.keys(map)
        .includes(value);
    },
    getCustomStatusClass(value, map) {
      return Object.entries(map)
        .find(([val]) => val === value)[1];
    },
    getCustomStatusField(value, item) {
      return Object.prototype.hasOwnProperty
        .call(item, value) ? item[value] : undefined;
    },
    getValue(item, property) {
      return property.includes('.') ?
        item[property.split('.')[0]][property.split('.')[1]] :
        item[property];
    },
    isDateField(header) {
      const fieldName = header.value.toLowerCase();
      return fieldName.endsWith('date') || fieldName.endsWith('at') ||
          fieldName.endsWith('time');
    },
    isBooleanType(header) {
      if (header.fieldType) {
        const fieldType = header.fieldType.toLowerCase();
        return fieldType === 'boolean';
      }
      return false;
    },
    decodeUriFilterValue(value) {
      return value === undefined ? '' : decodeURI(value);
    },
    columnAllowed(name) {
      return this.allowedHeaders.map(h => h.value)
        .includes(name);
    },
    resetPagination() {
      this.pagination.page = 1;
    },
    /* eslint-disable no-param-reassign */
    updateFiltering(property, preventUpdateOnFocusLoss, event) {
      if (preventUpdateOnFocusLoss) {
        return;
      }
      event = event || '';
      let value;
      if (event.target) {
        value = event.target.type === 'checkbox' ? event.target.checked : event.target.value.trim();
      } else {
        value = event;
      }
      this.resetPagination();
      this.applyFinancingFilter();
      this.filtering[property] = value;
      this.getItems();
    },
    updateSorting(header) {
      if (header.sortable === false) {
        return;
      }
      if (this.pagination.sortBy === header.value) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = header.value;
        this.pagination.descending = false;
      }
    },
    sortingClasses(header) {
      const classes = [];
      if (header.sortable !== false) {
        classes.push('sortable');
      }
      if (header.align) {
        classes.push(`text-xs-${header.align}`);
      } else {
        classes.push('text-xs-left');
      }
      const beingSorted = this.pagination.sortBy === header.value;
      if (beingSorted) {
        classes.push('active');
        if (this.pagination.descending) {
          classes.push('desc');
        } else {
          classes.push('asc');
        }
      }
      if (header.text === '') {
        classes.push('px-0');
      }
      return classes;
    },
    cellClass(header) {
      let result = '';
      if (this.cellClasses && this.cellClasses[header.value]) {
        result += `${this.cellClasses[header.value]} `;
      }
      if (header.align === 'right') {
        result += 'text-xs-right ';
      } else if (header.align === 'center') {
        result += 'text-xs-center ';
      } else {
        result += 'text-xs-left ';
      }
      return result;
    },
    getItems() {
      if (this.loading) {
        return;
      }

      this.items = [];
      this.resetErrors();
      this.loading = true;

      const rowsPerPage = this.defaultRowPerPageForSpecificTabs
        .find(e => e.title === this.$route.meta.title);
      if (rowsPerPage) {
        this.pagination.rowsPerPage = rowsPerPage.size;
      }

      if (this.parentId) {
        this.query = queries[this.queryFunctionName](
          this.parentId, this.pagination, this.filtering);
      } else {
        this.query = queries[this.queryFunctionName](this.pagination, this.filtering);
      }
      axios.get(this.query)
        .then((response) => {
          this.items = response.data.content || [];
          this.enumerations = response.data.enumerations || {};
          this.totalItems = response.data.totalElements;
          this.serverReturnedNothing = this.items.length === 0;
          this.loading = false;
          setTimeout(() => {
            const offset = (this.pagination.page - 1) * this.pagination.rowsPerPage;
            const start = offset + 1;
            const end = Math.min(offset + this.pagination.rowsPerPage, this.totalItems);
            const paginationElement = document.getElementsByClassName('v-datatable__actions__pagination')[0];
            paginationElement.innerHTML = `${start} - ${end}`;
          }, 100);
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
    getItemsAsCsv() {
      const timeZone = store.getters.timezone;
      const url = queries[this.csvQueryFunctionName](this.pagination, this.filtering, timeZone);
      const win = window.open(url, '_blank');
      win.focus();
    },
    resetErrors() {
      this.clearMessages();
      this.serverReturnedNothing = false;
    },
    resetFilters() {
      this.filtering = {};
      this.getItems();
    },
    applyFinancingFilter() {
      if (!this.canApplyFinancingFilter) {
        return;
      }
      this.filtering = Object.assign(this.filtering, this.financingFilter);
    },
  },

  watch: {
    pagination: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
    financingFilter: {
      handler() {
        this.updateFiltering();
      },
      deep: true,
    },
  },

  mounted() {
    this.filtering = queries.getFiltering(this);
    this.applyFinancingFilter();
    axios.get(queries.csvRecordsLimit())
      .then((response) => {
        this.recordsLimit = response.data.recordsLimit;
      });
  },
};
</script>

<style>
.data-table__row:nth-child(odd) {
  background-color: #f9f9f9;
}

.data-table__row a {
  text-decoration: none;
}

.data-table__header__filter-row {
  border-bottom: solid 1px lightgray;
}

.data-table__footer__filter {
  min-height: 32px !important;
}

.data-table__footer__filter,
.data-table__header-filter__drop-down .v-select__slot {
  border: solid 1px lightgray;
  width: 100%;
}

.data-table__footer__filter::placeholder {
  color: #d3d3d3;
}

.data-table__header-filter__drop-down .v-input__slot {
  box-shadow: none !important;
  padding-left: 0 !important;
}

.data-table__header-filter__drop-down .v-select__selection {
  font-size: 14px !important;
  font-weight: bold !important;
  margin: 0 0 0 0;
}

.data-table__header-filter__drop-down .v-input__append-inner {
  padding: 0;
}

.data-table__header-filter__drop-down .v-select__slot > .v-input__append-inner .v-icon {
  font-size: 16px;
}

.v-datatable__actions__range-controls .v-btn {
  color: #00BCD4 !important;
}

.data-table-scrollable-wrapper {
  overflow-x: scroll;
  background-color: white;
}

.data-table-scrollable-wrapper .data-table-built-in-wrapper {
  height: calc(100vh - 243px);
  background-color: white;
}

.data-table-scrollable-wrapper .data-table-built-in-wrapper .v-table__overflow {
  overflow-y: inherit !important;
}

.data-table-scrollable-wrapper .data-table-built-in-wrapper
.v-table__overflow table tr:nth-child(1) th {
  background: white;
  position: sticky;
  top: 0;
  z-index: 10;
}

.data-table-scrollable-wrapper .data-table-built-in-wrapper
.v-table__overflow table tr:nth-child(1) th:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -1px;
  padding-bottom: 1px;
  background-color: white;
  width: 100%;
  border-bottom: 1px solid lightgray;
}

/* table footer */
.data-table-scrollable-wrapper .data-table-built-in-wrapper .v-datatable {
  background: white;
  position: sticky !important;
  bottom: 0 !important;
  left: 0 !important;
  border-top-right-radius: 30px;
}

.data-table-scrollable-wrapper .data-table-built-in-wrapper .v-datatable .v-datatable__actions {
  border: none;
  background-color: #CDEDFD;
  border-top-right-radius: 30px;
}

.data-table-scrollable-wrapper .data-table-built-in-wrapper .v-datatable .v-datatable__actions
> div:nth-child(3) {
  border-top-right-radius: 30px;
}

.secondary--text {
  color: #00BCD4 !important;
  caret-color: #00BCD4 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/MPayGenericPagingTable.vue